Array.prototype.removeDuplicates = function () {
  let target = this;
  return target.filter((filterItem, index, self) => self.indexOf(filterItem) === index);
};

Array.prototype.findDuplicates = function () {
  let target = this;
  return target.filter((filterItem, index, self) => self.indexOf(filterItem) !== index);
};
